import { ChevronDownIcon } from '@heroicons/react/24/outline'

export default function ConfigSection({ title, description, children, isActive, onClick }) {
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden transition-all">
      <button
        onClick={onClick}
        className={`w-full flex items-center justify-between px-5 py-4 text-left transition-colors ${
          isActive ? 'bg-slate-50' : 'bg-white hover:bg-slate-50/50'
        }`}
      >
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
          {description && (
            <p className="text-xs text-slate-500 mt-0.5">{description}</p>
          )}
        </div>
        <ChevronDownIcon
          className={`h-4 w-4 text-slate-400 flex-shrink-0 ml-3 transition-transform duration-200 ${
            isActive ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        className={`transition-all duration-200 ease-in-out overflow-hidden ${
          isActive ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-5 pt-2 border-t border-slate-100 space-y-4">
          {children}
        </div>
      </div>
    </div>
  )
}
